import styled from "styled-components";

export const NEXT = "NEXT";
export const PREV = "PREV";


export const CarouselContainerWithArrow = styled.div`
  display: flex;
  transition: ${props => (props.sliding ? "none" : "transform 0.2s ease")};
  transform: ${props => {
    if (!props.sliding) return "translateX(0%)";
    if (props.dir === PREV) return "translateX(calc(2 * (-1%)))";
    if (props.dir === NEXT) return "translateX(calc(2 * (1%)))";
    return "translateX(0%)";
  }};
`;
export const CarouselContainer = styled.div`
  display: flex;
  transition: ${props => (props.sliding ? "none" : "transform 0.2s ease")};
  transform: ${props => {
    if (!props.sliding) return "translateX(-10%)";
    if (props.dir === PREV) return "translateX(calc(2 * (-10%)))";
    return "translateX(0%)";
  }};
`;


export const CarouselSlot = styled.div`
  flex-basis: 80%;
  order: ${props => props.order};
`;

export const SlideButton = styled.button`
   color: #000;
   background-color: #ffffff;
   position:absolute;
  font-family: Open Sans;
  font-size: 20px;
  font-weight: 100;
  border-radius:50%;
  box-shadow: 0px 5px 4px #3B3D404D;
  border: 1px solid rgb(239, 239, 239);
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  text-decoration: none;
  float: ${props => props.float};
  left: ${props => props.left}px;
  right: ${props => props.right}px;
  padding:5px;
  margin-top: ${props => props.marginTop || 95}px;
  height: ${props => props.height || 40}px;
  width: ${props => props.width || 40}px;
  z-index:101;
  &:active {
    position: relative;
    top: 1px;
  }
  &:focus {
    outline: 0;
  }
  `;




// WEBPACK FOOTER //
// ./src/components/Helpers/Widgets/SwipeCarousel/components.js